export const getDiscountRate = (prev: number, next: number): number => {
  // prev > next
  return Math.floor(((prev - next) / prev) * 100);
};
